export default "__VITE_ASSET__af79b223__"